import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import rootReducer from './rootReducer'
import { forumOutboxMiddleware } from './slices/forumOutboxSlice'

const middleware = getDefaultMiddleware({ serializableCheck: false }).concat(forumOutboxMiddleware)

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
})

// Do not silently discard source bytes if refresh happens before the initial
// IndexedDB commit. Once durable, refresh needs no warning and resumes normally.
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', (event) => {
    if (store.getState().forumOutbox.messages.some((job) => job.ready === false)) {
      event.preventDefault()
      event.returnValue = ''
    }
  })
}

export type RootState = ReturnType<typeof rootReducer>

export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
